module.exports = __webpack_public_path__ + "img/start.a5172133.png";